module.exports = __webpack_public_path__ + "static/mca-design.b3d19a66.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/mca/mca-design.jpeg
// module id = 471
// module chunks = 181542127041897